import DataTable from "react-data-table-component";

function DataTableBase(props) {
  return <DataTable {...props} />;
}

export default DataTableBase;
